import { getFocusableElements } from '../get-focusable-elements';

/**
 * Add tab index 0 to visible slides and -1 for hidden
 * Visibility based on param slides per view
 * If the slider uses the parameter SliderPerView:auto. Be sure to use watchSlidesProgress:true as well
 * @param {Object} swiper - Swiper instance object
 *
 * @return {void}
 */
export const addSlidesTabIndex = (swiper) => {
    const visibleSlidesCount = swiper.el.querySelectorAll('.swiper-slide-visible')?.length;

    swiper.slides.forEach((slide, index) => {
        /* eslint-disable */
        let slidesPerView = swiper.params.slidesPerView;
        /* eslint-enable */
        if (slidesPerView === 'auto' && slide.classList.contains('swiper-slide-visible')) {
            slidesPerView = visibleSlidesCount;
        }

        const isActiveSlide = index >= swiper.activeIndex && index < swiper.activeIndex + slidesPerView;
        const currentTabIndex = isActiveSlide ? '0' : '-1';

        getFocusableElements(slide).forEach((element) => {
            element.setAttribute('tabindex', currentTabIndex);
        });
    });
};
